<section class="banner-now-twelve">
  <div class="banner-now-twelve__left">
    <p class="banner-text now-12-18">ahora
      <span class="banner-capital-text">12</span>
    </p>
    <p class="banner-text thrusday-sunday">cuotas ¡todos los días!</p>
  </div>
  <div class="banner-now-twelve__center">
    <img [src]="imgNowTwelve" alt="Ahora12">
  </div>
  <div class="banner-now-twelve__right">
    <div class="card-types-content">
      <div class="card-now-12" alt="American Express"></div>
      <div class="card-amex" alt="American Express"></div>
      <div class="card-visa" alt="Visa"></div>
      <div class="card-mastercard" alt="Mastercard"></div>
    </div>
  </div>
</section>
